module.exports = __webpack_public_path__ + "img/subBanner8.ee6ae94f.png";